import React from 'react'

const Buttons = () => {
  return (
    <div className="button">
        <a href="http://" className='btn'>Download CV</a>
        <a href="#contact" className='btn btn_prim'>Lets Talk</a>
    </div>
  )
}

export default Buttons